export default "__VITE_ASSET__bb01115e__"